// extracted by mini-css-extract-plugin
export var form = "_3u-0";